import { PunctualityReportRepository } from '@src/main/modules/reports/punctuality/domain/punctuality-report.repository';
import { parsePunctualityReportCriteria } from '@src/main/modules/reports/punctuality/infrastructure/mapper/report-criteria.mapper';
import {
  PunctualityDetail,
  PunctualityReport,
  PunctualityReportCriteria,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

const path = '/forms';

export const createPunctualityReportHttpRepository = (
  tokenProvider: TokenProvider,
): PunctualityReportRepository => new PunctualityReportHttpRepository(tokenProvider);

class PunctualityReportHttpRepository implements PunctualityReportRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) {
      throw new Error('Authentication token is missing');
    }
    return token;
  }

  async findByCriteria(
    criteria: PunctualityReportCriteria,
  ): Promise<PageResponse<PunctualityReport>> {
    const token = await this.getAuthToken();
    const params = parsePunctualityReportCriteria(criteria);
    const response = await api.get<PageResponse<PunctualityReport>>(`${path}/all`, token, params);
    return response;
  }

  async findDetailed(criteria: PunctualityReportCriteria): Promise<PunctualityDetail[]> {
    const token = await this.getAuthToken();
    const params = parsePunctualityReportCriteria(criteria);
    const response = await api.get<PunctualityDetail[]>(`${path}/all/detailed`, token, params);
    return response;
  }

  async downloadPdf(formId: string): Promise<Blob> {
    const token = await this.getAuthToken();
    return await api.fetchBlob(`${path}/${formId}/pdf`, token);
  }

  async softDelete(formId: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.patch(`${path}/${formId}/soft`, token, {});
  }
}
